import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  summaryRoot: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(1),
  },
  trainingSetGroupsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      // padding: theme.spacing(0, 1),
    },
  },
  fileContainer: {
    ...theme.mixins.appContainer,
    display: 'flex',
    justifyContent: 'center',
  },
  label: {
    ...theme.mixins.appLabel,
  },
}));
